<template>
  <div class="vch-media-gallery__wrapper">
    <slot />

    <vch-carousel-indicator
      indicator-type="navigation"
      item-selector=".vch-media-gallery-mobile .vch-media-gallery__item"
      media-query-list="(max-width: 1023px)"
      :aria-pagination-label="paginationLabel"
      :aria-item-label="itemLabel"
      :key="lastUpdate"
      :currentItem.sync="activeSlide"
    />
    <div class="vch-media-gallery_sample">
      <ul>
        <li class="vch-media-gallery__item__video">
          <div class="vch-media-gallery__item-img-wrapper">
            <iframe
              class="youtube-player youtube-player--desktop"
              title="desktop video"
            ></iframe>
            <iframe
              class="youtube-player youtube-player--mobile"
              title="mobile video"
            ></iframe>
          </div>
        </li>
        <li class="vch-media-gallery__item__image">
          <div class="vch-media-gallery__item-img-wrapper primary-image">
            <picture>
              <source data-width="432" srcset="" media="(min-width: 1600px)" />
              <source data-width="339" srcset="" media="(min-width: 1280px), (min-width: 400px)" />
              <source data-width="238" srcset="" media="(min-width: 1024px)" />
              <source data-width="728" srcset="" media="(min-width: 425px)" />
              <img alt="Media Gallery Image" src="" class="vch-media-gallery__item-img-element" />
            </picture>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { eventBus } from 'EventBus/';
import { busName } from 'Directives/variant-selector/variant-selector';
import { mapMutations } from 'vuex';

export default {
  name: 'vch-media-gallery',
  data() {
    return {
      variantMedia: {},
      mediaItemElms: [],
      defaultSizeAttr: '',
      lastUpdate: Date.now(),
      defaultEAN: null,
      isEbsLoaded: false,
      activeSlide:0
    };
  },
  props: {
    paginationLabel: {
      type: String,
      required: false,
      default: '',
    },
    itemLabel: {
      type: String,
      required: false,
      default: '',
    },
    variantMediaItems: {
      type: String,
      required: false,
    },
    dataDefaultVariant: { 
      required: false, 
      type: String 
    },
    isEbsEnabled: { 
      required: false, 
      type: Boolean, 
      default: false 
    },
  },
  mounted() {
    eventBus.$on(`${busName}::selected`, this.updateMediaItems);

    if (this.variantMediaItems) {
      this.variantMedia = JSON.parse(this.variantMediaItems);
    }
    if(this.isEbsEnabled){
      this.processEBS();
    }
  },
  beforeDestroy() {
    eventBus.$off(`${busName}::selected`, this.updateMediaItems);
  },
  methods: {
    ...mapMutations('productEbs', ['SET_IS_EBS_ENABLED', 'SET_IS_EBS_LOADED']),
    updateMediaItems(productEan) {
      const nextItems = this.variantMedia?.[productEan];
      if (nextItems) {
        const listWrappers = document.querySelectorAll('.vch-media-gallery__list');
        listWrappers.forEach(wrapper => {
          wrapper.innerHTML = '';
        });

        nextItems.forEach((variantImages, i) => {
          if (variantImages[0].media === 'video') {
            this.updateNewVideo(variantImages, i);
          } else if (variantImages[0].media === 'image') {
            this.appendNewImage(variantImages, i);
          }
        });
      }
      document
        .querySelector('#vch-media-gallery__item-0')
        .classList.add('--packshot');

      const imgEle = document.querySelector('#vch-media-gallery__item-0 img');
      if (imgEle) {
        imgEle.id = 'main-image';
      }

      this.lastUpdate = Date.now();
      //update the image carousel 
      const productImages = nextItems.map(imageSet => {
        const image900 = imageSet.find(image => image.width === "900");
        return image900 ? { src: image900.url } : null;
      })
        .filter(Boolean); // remove nulls
      eventBus.$emit('update-product-images', productImages);
    },

    appendNewImage(imageData, index) {
      const mobileParentElement = document.querySelector('.vch-media-gallery__list.vch-media-gallery-mobile');
      const desktopParentElement = document.querySelector('.vch-media-gallery__list.vch-media-gallery-desktop');
      const previousNode = document.querySelector('.vch-media-gallery__item__image');

      const imageListItem = previousNode.cloneNode(true);
      imageListItem.classList.add('vch-media-gallery__item');
      imageListItem.id = `vch-media-gallery__item-${index}`;

      mobileParentElement.append(imageListItem);
      this.setImageAttribute(imageListItem.firstChild.firstChild, imageData);

      if (index === 0) {
        const desktopImageItem = previousNode.cloneNode(true);
        desktopImageItem.classList.add('vch-media-gallery__item');
        const isMobile = window.matchMedia('(max-width: 1023px)').matches;
        const desktopImageItemID = isMobile ? `desktop-vch-media-gallery__item-${index}` : `vch-media-gallery__item-${index}`;
        desktopImageItem.id = desktopImageItemID;

        desktopParentElement.append(desktopImageItem);
        this.setImageAttribute(desktopImageItem.firstChild.firstChild, imageData);
      }
    },

    updateNewVideo(imageData, index) {
      const mobileParentElement = document.querySelector('.vch-media-gallery__list.vch-media-gallery-mobile');
      const desktopParentElement = document.querySelector('.vch-media-gallery__list.vch-media-gallery-desktop');
      const previousNode = document.querySelector('.vch-media-gallery__item__video');
      const videoListItem = previousNode.cloneNode(true);
      videoListItem.classList.add('vch-media-gallery__item');
      videoListItem.id = `vch-media-gallery__item-${index}`;
      mobileParentElement.append(videoListItem);
      this.setVideoAttribute(videoListItem.firstChild, imageData);

      if (index === 0) {
        const desktopVideoListItem = previousNode.cloneNode(true);
        desktopVideoListItem.classList.add('vch-media-gallery__item');
        desktopVideoListItem.id = `vch-media-gallery__item-${index}`;

        desktopParentElement.append(desktopVideoListItem);
        this.setImageAttribute(desktopVideoListItem.firstChild, imageData);
      }
    },

    setImageAttribute(pictureElm, imageData) {
      pictureElm.querySelector('img').setAttribute('src', imageData[0].url);
      const sources = pictureElm.querySelectorAll('source');
      sources.forEach((srcElm, index) => {
        if (index < imageData.length) {
          const widthKey = imageData[index].width;
          if (widthKey) {
            srcElm.setAttribute('srcset', imageData[index].url);
          }
        }
      });
    },
    setVideoAttribute(pictureElm, imageData) {
      imageData.forEach((srcElm, index) => {
        let youtubeIdDesktop, youtubeIdMobile;
        if (srcElm.width === '1073') {
          youtubeIdDesktop = srcElm.desktopUrl;
          let youtubeUrlDesktop =
            'https://www.youtube.com/embed/' +
            youtubeIdDesktop +
            '?rel=0&autoplay=0&mute=0&loop=1&color=white&controls=1&modestbranding=1&playsinline=1&enablejsapi=1';
          pictureElm.querySelector('.youtube-player--desktop').src =
            youtubeUrlDesktop;

          youtubeIdMobile = srcElm.mobileUrl
            ? srcElm.mobileUrl
            : youtubeIdDesktop;
          let youtubeUrlMobile =
            'https://www.youtube.com/embed/' +
            youtubeIdMobile +
            '?rel=0&autoplay=0&mute=0&loop=1&color=white&controls=1&modestbranding=1&playsinline=1&enablejsapi=1';
          pictureElm.querySelector('.youtube-player--mobile').src =
            youtubeUrlMobile;
        }
      });
    },
    async processEBS() {
      let ebsFound = await this.waitForEbsElement();
      if (!ebsFound) return;
      this.isEbsLoaded = true;
      this.$nextTick(() => {
        this.getDefaultEAN(); 
      });
      this.SET_IS_EBS_ENABLED(this.isEbsEnabled);  
      this.SET_IS_EBS_LOADED(this.isEbsLoaded);
    },
    waitForEbsElement() {
      const orionExperienceElement = "orion-experience"

      const orionElementExists = () => document.querySelector(orionExperienceElement)

      const nodeMatches = (node) =>
          node.matches?.(orionExperienceElement) ||
          node.querySelector?.(orionExperienceElement)

      return new Promise((resolve) => {
          if (orionElementExists()) return resolve(true);

          const observer = new MutationObserver((mutations) => {
              for (const { addedNodes } of mutations) {
                  for (const node of addedNodes) {
                      if (node instanceof HTMLElement && nodeMatches(node)) {
                          observer.disconnect();
                          return resolve(true);
                      }
                  }
              }
          });

          observer.observe(document.body, {
              childList: true,
              subtree: true,
          });

          setTimeout(() => {
              observer.disconnect();
              resolve(false);
          }, 5000);
      })
    },
    setEbsEAN(EAN) {
      if (typeof window.RefApp?.DSF?.SetEANNumber === 'function') {
        window.RefApp.DSF.SetEANNumber(EAN);
      }
    },
    getDefaultEAN() {
      let singleVariant = document.querySelector(".vchy-package-size-selector.single-varient");
      let multiVariant = document.querySelector(".vchy-package-size-selector__list div[aria-selected='true']");
      let shadeVariant = document.querySelector('.vch-slider__list .shade-swatch input[name="selected-shade"]:checked');

      let dataEan = null;
      
      if (singleVariant) {
        dataEan = singleVariant.getAttribute('data-ean');
      } else if (multiVariant) {
        dataEan = multiVariant.getAttribute('id');
      } else if (shadeVariant) {
        let shadeLabel = document.querySelector(`label[for="${shadeVariant.id}"]`);
        dataEan = shadeLabel?.getAttribute('data-ean')?.trim();
      } else {
        dataEan = this.dataDefaultVariant;
      }
      this.defaultEAN = dataEan;
      this.setEbsEAN(this.defaultEAN);
    }
  },
};
</script>